import { SignDirectionMinusIcon } from './SignDirectionMinusIcon';

/**
 * author: Michael Richins
 * id 110700C4-EF32-4835-B9C6-ECE259438B80
 * name sign-direction-minus
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-direction-minus.svg
 * tags
 */
export const MilestoneMinusIcon = SignDirectionMinusIcon;
export default MilestoneMinusIcon